<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-button type="default" icon="el-icon-s-fold" @click="collapseHTree"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="addPkgPrice()">新增</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" :model="formQuery" size="mini" class="smui-form-right">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
            <div class="sanmuui-body-left" v-show="displayHTreeVisible">
              <div class="tree-divBox">
                  <el-tree 
                      :data="holdTreeData" 
                      :props="defaultProps" 
                      default-expand-all 
                      ref="getTreeInstance" 
                  @node-click="handleNodeClick"></el-tree>
              </div>
            </div>
            <div class="sanmuui-body-right">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="用户"
                  width="220">
                </el-table-column>
                <el-table-column
                  prop="package_name"
                  label="套餐名称"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="price"
                  label="价格(元)"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="period_usage"
                  label="用量(MB)"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="period_months"
                  label="周期(月)"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="source_name"
                  label="卡源"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  fixed="right"
                  label="更多"
                  width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="displayEditForm(scope.row.id)">编辑</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <el-drawer
        title="订单详情"
        :visible.sync="drawer"
        :with-header="false"
        :direction="direction">
        <div class="dr-container">
          <el-table
              :data="renewalsCardListTable"
              border
              style="width: 100%">
              <el-table-column
                  prop="iccid"
                  label="ICCID"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="sim"
                  label="SIM"
                  width="150">
              </el-table-column>
              <el-table-column
                  prop="ex_expired"
                  label="续费前到期"
                  width="150">
              </el-table-column>
              <el-table-column
                  prop="now_expired"
                  label="当前到期"
                  width="150">
              </el-table-column>
          </el-table>
        </div>
    </el-drawer>

    <!-- 新增套餐价格 -->
    <el-dialog title="新增套餐价格" :visible.sync="addDialogVisible" width="600px" :center="true">
      <el-row>
        <el-col :span="10">
          <div class="tree-divBox">
              <el-tree 
                  :data="holdTreeData" 
                  :props="defaultProps" 
                  default-expand-all 
              @node-click="handleHoldNodeClick"></el-tree>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="divForm-add">
            <el-form :model="formPkgPrice" :rules="ruleForm" ref="formPkgPrice" size="small">
              <el-form-item label="请选择用户(选左边组织树节点)" prop="parent">
                  <el-input v-model="formPkgPrice.newHoldName" autocomplete="off" :disabled="true" class="fm2-input-text-wth"></el-input>
              </el-form-item>
              <el-form-item label="卡源" prop="source_id">
                  <select v-model="formPkgPrice.source_id" @change="loadPkgOptionItems" class="fm-select-control">
                      <option v-for="item in source_options" :value="item.value">{{item.label}}</option>
                  </select>
              </el-form-item>
              <el-form-item label="套餐" prop="pkg_id">
                  <select v-model="formPkgPrice.pkg_id" class="fm-select-control">
                      <option v-for="item in package_options" :value="item.value">{{item.label}}</option>
                  </select>
              </el-form-item>
              <el-form-item label="价格" prop="price">
                  <el-input v-model="formPkgPrice.price" autocomplete="off" class="fm2-input-text-wth"></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="status">
                  <el-radio-group v-model="formPkgPrice.status">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">关闭</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                  <el-input type="textarea" v-model="formPkgPrice.remark" style="height: 150px;"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitPkgPrice('formPkgPrice')" size="small">提 交</el-button>
      </div>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'renewals_order',
  data() {
    return {
      displayHTreeVisible: true,
      addDialogVisible: false,
      order_time: null,
      formQuery: {
        order_no: '',
        iccid: '',
        hold_id: null,
        start_time: null,
        end_time: null,
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      formLabelWidth: "110px",
      formPkgPrice: {
        id: 0,
        hold_id: 0,
        newHoldName: "",
        source_id: null,
        pkg_id: null,
        price: "",
        status: "1",
        remark: null
      },
      ruleForm: {
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
      },
      source_options: [],
      package_options: [],
      rules: {
        iccids: [
          { required: true, message: '请输入ICCID号', trigger: 'blur' }
        ],
        payload: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      drawer: false,
      direction: 'rtl',  // Drawer 抽屉: 从右往左开
      drActiveName: 'detail',
      renewalsCardListTable: [],
      selectHoldId: 0,
      selectedHoldName: "",
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.search();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 将字符串以逗号或换行符分割成数组
     * @param {string} str - 要分割的字符串
     * @returns {Array} 分割后的数组
     */
    splitByCommaOrNewline: function(str) {
      // 使用正则表达式匹配逗号或换行符（包括Windows和Unix风格的换行符）
      return str.split(/[,|\r\n|\n|\r]+/)
        // 过滤掉空字符串
        .filter(item => item.trim() !== '');
    },
    collapseHTree: function() {
      if(this.displayHTreeVisible) {
        this.displayHTreeVisible = false;
      } else {
        this.displayHTreeVisible = true;
      }
    },
    handleNodeClick: function(data) {
      this.formQuery.hold_id = data.id;
      //this.selectedHoldName = data.label;
      this.search();
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res || res.code !== 200)
          return;

        this.holdTreeData = res.data;
      });
    },
    handleHoldNodeClick: function(data) {
      this.formPkgPrice.hold_id = data.id;
      this.formPkgPrice.newHoldName = data.label;
    },
    loadSourceOptions: function() {
        this.source_options = [];
        Api.SourceOptions({}).then(res => {
            if(res && res.data) {
                res.data.forEach(element => {
                    this.source_options.push({
                        value: element.source_id,
                        label: element.source_name
                    })
                });
                this.formPkgPrice.source_id = res.data[0].source_id;
                this.loadPkgOptionItems();
            }
        });
    },
    loadPkgOptionItems: function() {
        var argdata = {
            source_id: this.formPkgPrice.source_id
        }
        this.package_options = []
        Api.QueryPkgOptionItems(argdata).then(res => {
            if(res && res.code === 200) {
                res.data.forEach(element => {
                    this.package_options.push({
                        value: element.package_id,
                        label: element.package_name
                    })
                });
                this.formPkgPrice.package_id = res.data[0].package_id;
            }
        })
    },
    search: function() {
      this.loadingTableData = true;
      this.tableData = [];

      if(this.order_time) {
        this.formQuery.start_time = this.order_time[0];
        this.formQuery.end_time = this.order_time[1];
      }
      this.formQuery.page_index = this.pagging.current_page;
      this.formQuery.page_size = this.pagging.pager_size;
      Api.PkgPriceList(this.formQuery).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    addPkgPrice: function() {
      this.addDialogVisible = true;
    },
    displayEditForm: function(id) {
      this.addDialogVisible = true;
      Api.PkgPriceDetail({id: id}).then(res => {
        if(res && res.code === 200 && res.data) {
          this.formPkgPrice.id = res.data.id;
          this.formPkgPrice.hold_id = res.data.hold_id;
          this.formPkgPrice.newHoldName = res.data.hold_name;
          this.formPkgPrice.pkg_id = res.data.pkg_id;
          this.formPkgPrice.source_id = res.data.source_id;
          this.formPkgPrice.price = res.data.price;
          this.formPkgPrice.status = `${res.data.status}`;
          this.formPkgPrice.remark = res.data.remark;
        } else {
          this.$message.error('获取数据异常');
        }
      });
    },
    submitPkgPrice: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 保存套餐价格信息
          console.log(this.formPkgPrice)
          this.formPkgPrice.status = parseInt(this.formPkgPrice.status);
          Api.AddPkgPrice(this.formPkgPrice).then(res => {
            if(res && res.code === 200) {
              this.$message.info("保存成功！");
              this.addDialogVisible = false;
              this.search();
            } else {
              this.$message.error('保存失败！');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 130;
    var h2 = document.body.clientHeight - 240;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.search();
    this.loadHoldTree();
    this.loadSourceOptions();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
.divForm-add {
  padding-left: 15px;
}
</style>